// app/javascript/controllers/practice_dropdown_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "menu", "arrow", "content"]
  
  connect() {
    this.boundClickOutside = this.clickOutside.bind(this)
    this.boundEscapeKey = this.handleEscape.bind(this)
  }
  
  disconnect() {
    this.removeEventListeners()
  }
  
  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    if (this.isOpen()) {
      this.hide()
    } else {
      this.show()
    }
  }
  
  show() {
    this.menuTarget.classList.remove("hidden")
    this.loadContent()
    this.rotateArrow(true)
    
    // Add event listeners with a small delay to prevent immediate triggering
    setTimeout(() => {
      document.addEventListener("click", this.boundClickOutside)
      document.addEventListener("keydown", this.boundEscapeKey)
    }, 10)
  }
  
  hide() {
    this.menuTarget.classList.add("hidden")
    this.rotateArrow(false)
    this.removeEventListeners()
  }
  
  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }
  
  handleEscape(event) {
    if (event.key === "Escape") {
      this.hide()
    }
  }
  
  rotateArrow(isOpen) {
    if (this.hasArrowTarget) {
      if (isOpen) {
        this.arrowTarget.style.transform = "rotate(180deg)"
      } else {
        this.arrowTarget.style.transform = "rotate(0deg)"
      }
    }
  }
  
  // The subjects grid isn't in the page; it's fetched once, the first time the menu opens.
  async loadContent() {
    if (!this.hasContentTarget || this.contentLoaded) return
    this.contentLoaded = true
    try {
      const response = await fetch(this.contentTarget.dataset.url, { headers: { Accept: "text/html" } })
      if (!response.ok) throw new Error(response.status)
      this.contentTarget.innerHTML = await response.text()
    } catch {
      this.contentLoaded = false
      this.contentTarget.innerHTML = '<p class="py-8 text-center text-sm text-gray-500 dark:text-gray-400">Couldn\u2019t load subjects. <a class="font-medium text-violet-700 hover:underline" href="/practice">See all subjects</a></p>'
    }
  }

  isOpen() {
    return !this.menuTarget.classList.contains("hidden")
  }
  
  removeEventListeners() {
    document.removeEventListener("click", this.boundClickOutside)
    document.removeEventListener("keydown", this.boundEscapeKey)
  }
}